document.querySelectorAll('.more').forEach( (button) => {
    button.addEventListener('click', () => {showMore(button)})
})

document.querySelectorAll('.close-more').forEach( (closeElem) => {
    closeElem.addEventListener('click', () => {hideMessage(closeElem.parentElement)})
})


function showMore(button)
{
    let source = button.getAttribute('attr-step');
    displayMessage(messages[source], button);
}

function displayMessage(message, button)
{

    let container = button.parentElement.parentElement.querySelector('.message') ?
        button.parentElement.parentElement.querySelector('.message') :
        document.querySelector('.mobile-message');
    
    container.querySelector('.stage').innerHTML = message.number;
    container.querySelector('.stage').style.color = message.color;
    container.querySelector('.title').innerHTML = message.title;
    container.querySelector('.message-container').innerHTML = message.message;
    
    container.classList.add('show');

}

function hideMessage(element)
{
    element.classList.remove('show');
}

let messages = {
    concept: {
        number: '01',
        title: 'The Concept',
        message: 'There are various reasons why we choose to develop a particular resource - it might be in response to requests from members; because we’ve spotted a curriculum gap that needs meeting; after consultation with literacy consultants; or just because one of our teacher-creators feels inspired!',
        color: '#24387D'
    },
    development: {
        number: '02',
        title: 'The Development',
        message: 'From an original idea, our teacher-creators work with colleagues and consultants to create a resource that will have real impact in the classroom, and deliver exactly what teachers want and need.',
        color: '#47BBC3'
    },
    design: {
        number: '03',
        title: 'The Design',
        message: 'We have an incredibly talented team of designers, who love nothing better than turning our creators’ work into clear, beautiful worksheets, writing frames, PowerPoints and more.',
        color: '#FBBA13'
    },
    proofing: {
        number: '04',
        title: 'The Proofing',
        message: 'We know that resources for the classroom can’t be ‘good enough’; these are being used to teach children, and so they need to be perfect. That’s why every Plazoom resource goes through three levels of checking before our editorial team finally signs it off to be shared with members.',
        color: '#3AAA35'
    },
    result: {
        number: '05',
        title: 'The Result',
        message: 'Once a resource has been given final approval, our tech team gets it ready to upload - making sure it’s easy for teachers to know what they are looking at, and tagging it so that it can easily be found if someone is looking for a particular curriculum point, topic or approach.',
        color: '#6379CC'
    },
    evolution: {
        number: '06',
        title: 'The Evolution',
        message: 'We never upload our resources and forget about them. We go back over our content regularly, checking to see if any updates are needed. We also listen to our members - and if they come up with an idea to make a resource even better, we’ll do our best to make it happen. Because ultimately, it’s the teachers in classrooms who know what really works.',
        color: '#EC6260'
    }
}